// extracted by mini-css-extract-plugin
module.exports = {"icons":"ClientCsvFormatsTable__icons--2BT0D"};